import { DataManagerService } from './model/services/data-manager.service';
import { EnvService } from 'app/env.service';
import { environment } from './../environments/environment';
import { ServerService } from 'app/model/services/api-services/server.service';
import { StatefulCSS } from './model/stateful_css';
import { Component, ElementRef, HostBinding, OnInit, ViewChild, ViewChildren } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  @HostBinding('class.connection-online') isOnline = true;
  public title = 'is-client';
  public logo:string = '/assets/images/alphasol.png';
  @ViewChild('pageTitleContainer',{static:true}) pageTitleContainer?:ElementRef<HTMLDivElement>;
  constructor(private env:EnvService, private server:ServerService,private dataMgr:DataManagerService) {}
  ngOnInit() {

    this.env.SetApp(this);
    window.addEventListener('resize', () => {
      this.UpdateSizes();
    });
    window.addEventListener('orientationchange', () => {
      this.UpdateSizes();
    });
    this.UpdateSizes();
    /*if(!this.server.HasSession()) {
      this.server.Login();
    }*/

  }
  UpdateSizes() {
    window.requestAnimationFrame(() => {
      document.documentElement.style.setProperty('--vw', document.body.clientWidth + 'px');
      document.documentElement.style.setProperty('--vh', document.body.clientHeight + 'px');
    })
  }
  GetPageTitle():undefined | HTMLDivElement  {
    return this.pageTitleContainer?.nativeElement;
  }
}

